/// <amd-module name="Search/Package/Components/ItemsList" />

import * as  React from "react";
import * as SharedResources from "Search/Shared/Resources";
import { PackageResult } from "Search/WebApi/Contracts/Search.Shared";
import { css } from "VSSUI/Util";
import { List, IListItemDetails, ListItem } from "VSSUI/List";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { FocusZoneDirection } from "VSSUI/FocusZone";
import { PackageItem } from "Search/Package/Components/PackageItem";

export interface IItemsListProps {
    items: PackageResult[];

    itemsLoading: boolean;

    notifyOnRendered(): void;

    onPackageItemClicked(link: string, evt: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>): void;

    renderLoadingRow(): JSX.Element;
}


export class ItemsList extends React.Component<IItemsListProps, {}> {
    private isRendered = false;

    public render(): JSX.Element {
        const { items } = this.props;
        return (
            <List
                className="items-list"
                itemProvider={new ArrayItemProvider(items)}
                renderRow={this.rowRenderer}
                focuszoneProps={{
                    focusOnMount: false,
                    disabled: false,
                    direction: FocusZoneDirection.Vertical,
                    handleTabKey: true
                }}
                selectableText={true}
                width="100%"
                ariaLabel={SharedResources.SearchResultsListAriaLabel} />
        );
    }

    private rowRenderer = (index: number, item: PackageResult, details: IListItemDetails<PackageResult>): JSX.Element => {
        const { onPackageItemClicked, renderLoadingRow } = this.props;
        const rowKey = "list-item" + index;

        return (
            <ListItem key={rowKey} index={index} details={details} className={css("search-item-list-row")}>
                {
                    !item.hasOwnProperty("name")
                        ? renderLoadingRow()
                        : <PackageItem
                            packageSearchResult={item}
                            onRenderComplete={this.onItemRenderComplete}
                            onPackageItemClicked={onPackageItemClicked}
                        />
                }
            </ListItem>
        );
    }

    private onItemRenderComplete = (): void => {
        if (!this.isRendered && !this.props.itemsLoading) {
            this.isRendered = true;
            this.props.notifyOnRendered();
        }
    }
}